/* tslint:disable:no-console */
import { ActionTree } from 'vuex'
import { FormState, Form } from './types'
import { RootState } from '@/store/types'
import { Http } from '@/api'


export const actions: ActionTree<FormState, RootState> = {
  loadForm: async ({ getters: _, commit }) => {
    const form: Form = await Http.get('api/forms/my')
    commit('loadForm', form.configuration)
  },
  loadWebForm: async ({ getters: _, commit }, { companyCode, formCode }) => {
    const url = `api/webforms/${companyCode}/my` + (formCode ? `/${formCode}` : '')
    const form: Form = await Http.get(url)
    commit('loadForm', form.configuration)
    commit("context/setReadonlyVariables", {
      variables: {
        "form.id": form.id,
        "form.code": formCode,
        "form.name": form.name,
        "form.configurationId": form.configuration_id,
        "form.companyId": form.company,
        "form.companyCode": companyCode,
        // for non readonly form.groupCode see event-manager.ts
      }
    }, { root: true })
  }
}
